import ModelTypeConstants from 'constants/ModelTypeConstants';
import {FileSummary} from 'folder-items/FileConstants';
import {getNavigationURL} from 'nav/sidepanel/listing/SearchURLs';
import {Filter, FilterKey, Operator} from 'search/SearchConstants';

export function entityIsContainable(entity: FileSummary): boolean {
  return entity.tagSchema == null ? false : entity.tagSchema.isContainable;
}

export function getInventorySearchUrlForContainable({
  containableId,
  registryId,
  storableId,
}: {
  containableId: string;
  registryId: string;
  storableId: string;
}): string {
  const filters: Array<Filter> = [
    {
      key: FilterKey.TYPES,
      operator: Operator.IS_ONE_OF,
      value: [ModelTypeConstants.CONTAINER],
    },
    {
      key: FilterKey.CONTAINER_CONTENTS,
      operator: Operator.HAS_ALL_OF,
      value: {contentIds: [containableId]},
    },
    {
      key: FilterKey.ANCESTOR_STORABLE,
      operator: Operator.IS,
      value: storableId,
    },
  ];
  const filterErrors = filters.map(() => null);

  const url = getNavigationURL(
    '/search',
    {
      offset: 0,
      limit: 25,
      query: '',
      filters,
      sorts: [],
    },
    filterErrors
  );
  return url;
}
